import EventPage from '@/pages/event/layout.vue'
import EventIndexPage from '@/pages/event/indexTabs/index.vue'
import EventPastPage from '@/pages/event/indexTabs/past.vue'
import EventCreatePage from '@/pages/event/indexTabs/create.vue'
import EventMapPage from '@/pages/event/map.vue'
import EventReservationIndexPage from '@/pages/event/reservation.vue'
import EventViewLayout from '@/pages/event/viewTabs/layout.vue'
import EventViewIndexPage from '@/pages/event/viewTabs/index.vue'
import EventViewMemberPage from '@/pages/event/viewTabs/member.vue'
// update
import EventUpdateIndexPage from '@/pages/event/updateTabs/index'

const routes = {
	path: '/events',
	component: EventPage,
	meta: {title: 'Мероприятия', breadcrumb: 'Мероприятия'},
	children: [
		{
			path: '',
			component: EventIndexPage,
			meta: {title: 'Мероприятия'}
		}, {
			path: 'past',
			component: EventPastPage,
			meta: {title: 'Мероприятия'}
		}, {
			path: 'create',
			component: EventCreatePage,
			meta: {title: 'Создание мероприятия'}
		}, {
			path: ':id',
			component: EventViewLayout,
			meta: {title: 'Мероприятия'},
			children: [
				{
					path: 'update',
					component: EventUpdateIndexPage,
					meta: {title: 'Редактирование мероприятия'}
				}, {
					path: 'view',
					component: EventViewIndexPage,
					meta: {title: 'Мероприятия'}
				}, {
					path: 'members',
					component: EventViewMemberPage,
					meta: {title: 'Учатсники меропрития'}
				}
			]
		}, {
			path: 'map/:id',
			component: EventMapPage
		},
		{
			path: 'reservation/:id',
			component: EventReservationIndexPage
		}
	]
}

export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/event.js